module.exports = __webpack_public_path__ + "img/icon_paper.2e58b79a.svg";